var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.98709 8.97417C8.20213 8.97417 9.97417 7.17444 9.97417 4.98708C9.97417 2.79973 8.17444 1 5.98709 1C3.79973 1 2 2.79973 2 4.98708C2 7.17444 3.79973 8.97417 5.98709 8.97417ZM13.7674 11.9922V34.198H20.6341V23.2335C20.6341 20.3263 21.1878 17.5298 24.7596 17.5298C28.3314 17.5298 28.3314 20.8524 28.3314 23.3997V34.198H35.2257V22.0153C35.2257 16.0346 33.9521 11.4384 26.9747 11.4384C23.6244 11.4384 21.3817 13.2658 20.468 15.0102H20.3849V11.9645H13.7951L13.7674 11.9922ZM2.55376 11.9922H9.4481V34.198H2.55376V11.9922Z",
    fill: "#F0C808"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.83f0bcfe27b778de7b38754177476309.svg";
export { ForwardRef as ReactComponent };